import { LoadSurgicalOrderNoticeCard } from 'domain/usecases/surgical-pendency/load-surgical-order-notice-card'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteLoadSurgicalOrderNoticeCard
  implements LoadSurgicalOrderNoticeCard
{
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}
  load(surgical_order_id: number): Promise<LoadSurgicalOrderNoticeCard.Model> {
    return this.surgicalPendencyRepository.loadSurgicalOrderNoticeCard(
      surgical_order_id
    )
  }
}
